var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.board)?_c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}]},[_c('schedule',{attrs:{"is-member":_vm.isMember,"objectives":_vm.getValidObjectives()},on:{"drag":_vm.drag}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }